// extracted by mini-css-extract-plugin
module.exports = {"container":"no-data-container_container__y_8wb","text":"no-data-container_text__W0YIY"};